module.exports = __webpack_public_path__ + "img/service-icon-pump.ff1b1bea.png";